import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";


interface IVacationPayReportHeader {
	setStateRunGetListAPICall: (value: boolean) => void
	payPeriodFrequencyDDLItems: any;
	employeeDDLItems: any;
	payPeriodEndDateDDL: any;

	onPeriodEndDateSelectionChangeHandler: (value: string) => void
	formMethods: any
}

export const VacationPayReportHeader: React.FC<
	IVacationPayReportHeader
> = ({ setStateRunGetListAPICall, payPeriodFrequencyDDLItems, employeeDDLItems, payPeriodEndDateDDL, onPeriodEndDateSelectionChangeHandler, formMethods }) => {

	const [isEndDateDisabled, setIsEndDateDisabled] = useState<boolean>(true);
	const [stateIsDateRangeDisabled, setStateIsDateRangeDisabled] = useState<boolean>(false);

	const onPayPeriodSelectionChangeHandler = (e: any) => {
		setStateRunGetListAPICall(false)
		onPeriodEndDateSelectionChangeHandler(e.value);
		setIsEndDateDisabled(e.value === "all")

		if (e.value === "all") {
			formMethods.setValue("payPeriodEndDate", "all");
			setStateIsDateRangeDisabled(false)
		}
	}

	const onPayPeriodEndDateSelectionChangeHandler = ({ value }: any) => {

		setStateRunGetListAPICall(false);

		const isAll = value === "all";
		setStateIsDateRangeDisabled(!isAll);

		if (isAll) return;
		const selectedLabel = payPeriodEndDateDDL && payPeriodEndDateDDL?.find(
			(item: any) => item.value === value
		)?.label;

		if (!selectedLabel) return;

		const [startDate, endDate] = selectedLabel.split(" to ");

		formMethods.setValue("startDate", new Date(startDate));
		formMethods.setValue("endDate", new Date(endDate));
	};


	const [showDateRange, setShowDateRange] = useState(false);
	const handleShowDateRangeChange = (e: any) => {
		setShowDateRange(e.value);
		setStateRunGetListAPICall(false)
	};

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "15px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>


				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeId"}
						items={employeeDDLItems ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>

				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"openBalance"}
						items={[
							{
								label: "Show",
								value: 200,
							},
							{
								label: "Don't Include",
								value: 100,
							},
						]}
						label={"Open Balance"}
						testId={"open-balance"}
						selectedItem={200}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>

				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriod"}
						items={payPeriodFrequencyDDLItems ?? []}
						selectedItem={"all"}
						label={"Pay Period"}
						testId={"pay-period-ddl"}
						// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"showReport"}
						items={[
							{ label: "Summarize", value: false },
							{ label: "Date Range", value: true },
						]}
						label={"Show Report"}
						testId={"show-report"}
						selectedItem={showDateRange}
						onSelectionChangeHandler={handleShowDateRangeChange}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				{showDateRange && (
					<Grid size={{ xs: 12, sm: 3, md: 2.5, lg: 2.5, xl: 2.5 }}
						sx={{
							"& .calenderWrapper ": { fontSize: ".875rem", },
							"& .MuiGrid-root ": { width: "296px!important" },
						}}>
						<>
							<RHookFormDatePicker
								name="startDate"
								testId="start-date"
								label="Start Date"
								labelPosition={LabelPosition.Top}
								format="M dd, yy"
								onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							/>
							<RHookFormDatePicker
								name="endDate"
								testId="end-date"
								label="EndDate"
								labelPosition={LabelPosition.Top}
								format="M dd, yy"
								onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							/>
						</> </Grid>
				)}
				{showDateRange && (
					<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				)}
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriodEndDate"}
						items={payPeriodEndDateDDL ?? []}
						selectedItem={"all"}
						label={"End Date"}
						testId={"end-date-ddl"}
						// // onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						onSelectionChangeHandler={onPayPeriodEndDateSelectionChangeHandler}
						isDisabled={isEndDateDisabled}

					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						label="Status"
						selectName="status"
						testId={`status`}
						labelPosition={LabelPosition.Top}
						items={[
							{ label: "All", value: "all" },
							{ label: "Active", value: 100 },
							{ label: "Terminated", value: 300 },
							{ label: "Died", value: 200 },
						]}
						selectedItem={100}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				</Grid>
			</Grid>
		</>
	);
};
